module.exports = __webpack_public_path__ + "21457ec8a69a8112b365bfe5f9cd1c74.png";